<template>
  <el-container>
    <el-header> <HeaderNav /></el-header>
    <el-main style="padding: 0">
      <keep-alive> <router-view /></keep-alive>
      <el-backtop target="#app" :bottom="100" style="border: none">
        <a class="custom-backtop">
          <i class="icon-up"></i>
          <span>回到顶部</span>
        </a>
      </el-backtop></el-main
    >
    <el-footer style="padding: 0"><LczyFooter /></el-footer>
  </el-container>
</template>

<script>
import HeaderNav from './HeaderNav.vue'
import LczyFooter from './LczyFooter.vue'

export default {
  name: 'LayoutView',
  components: {
    HeaderNav,
    LczyFooter
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-backtop) {
  width: auto;
  height: auto;
  border-radius: 0;
  box-shadow: none;
  background-color: transparent;

  .el-backtop :hover {
    background-color: transparent;
  }

  .custom-backtop {
    text-align: center;
    text-decoration: none;
    color: #d1d1d1;
    display: block;
    width: 64px;
    -webkit-transition: color 0.5s;
    transition: color 0.5s;
    .icon-up {
      background: transparent url(https://www.finebi.com/images/top.png) no-repeat;
      border-radius: 6px;
      display: block;
      height: 60px;
      width: 60px;
      margin: auto;
      margin-bottom: 5px;
    }

    span {
      font-size: 14px;
      text-align: center;
      text-decoration: none;
      color: #d1d1d1;
    }
  }
}
::v-deep .el-backtop:hover {
  background-color: transparent !important;
}
</style>
